import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-8167">
      <PaymentForm data-id="element-8168" />
    </div>;
}